import React, { useId } from "react";

import { Input } from "@/components/ui/input";

interface AdornmentInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "prefix"> {
  prefix?: string;
}

const AdornmentInput = ({
  prefix,
  ...props
}: AdornmentInputProps = {}): JSX.Element => {
  const id = useId();

  return (
    <div className='*:not-first:mt-2'>
      <div className='flex rounded-md shadow-xs'>
        {prefix && (
          <span className='inline-flex items-center px-2 text-sm border border-input bg-background text-muted-foreground -z-10 rounded-s-md text-nowrap'>
            {prefix}
          </span>
        )}
        <Input
          id={id}
          className='shadow-none -ms-px rounded-s-none'
          placeholder='google.com'
          type='text'
          {...props}
        />
      </div>
    </div>
  );
};

export default AdornmentInput;
